import { createElementObject, createOverlayComponent } from './core';
// import { Popup as LeafletPopup } from '@anlan/gs-map';
import { useEffect } from 'react';
import type { ReactNode } from 'react';
import L from '@anlan/gs-map';
import type { LatLngExpression, LeafletEventHandlerFnMap, Popup as LeafletPopupInstance, PopupEvent, PopupOptions } from '@anlan/gs-map';
import type { EventedProps, LeafletContextInterface } from './core';
import type { SetOpenFunc } from './core/div-overlay';
import type { LeafletElement } from './core/element';
const LeafletPopup = L.Popup;

export interface PopupProps extends PopupOptions, EventedProps {
    children?: ReactNode
    position?: LatLngExpression
}

export const Popup = createOverlayComponent<LeafletPopupInstance, PopupProps>(function createPopup(props: PopupProps, context: LeafletContextInterface) {
    const popup = new LeafletPopup(props, context.overlayContainer);
    return createElementObject(popup, context);
}, function usePopupLifecycle(element: LeafletElement<LeafletPopupInstance>, context: LeafletContextInterface, { position  }: PopupProps, setOpen: SetOpenFunc) {
    useEffect(function addPopup() {
        const { instance  } = element;
        function onPopupOpen(event: PopupEvent) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event: PopupEvent) {
            if (event.popup === instance) {
                setOpen(false);
            }
        }
        const handlers: LeafletEventHandlerFnMap = {
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        };
        context.map.on(handlers);
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) {
                instance.setLatLng(position);
            }
            instance.openOn(context.map);
        } else {
            // Attach to container component
            if (context.overlayContainer.bindPopup == null) {
                throw new Error('Overlay container does not support bindPopup');
            }
            context.overlayContainer.bindPopup(instance);
        }
        return function removePopup() {
            context.map.off(handlers);
            if (context.overlayContainer != null) {
                if (context.overlayContainer.unbindPopup == null) {
                    throw new Error('Overlay container does not support unbindPopup');
                }
                context.overlayContainer.unbindPopup();
            }
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});
